const SAFE_ID_REGEX = /^[a-zA-Z0-9-]+$/;

/**
 * Validates a potential ID from the router query.
 *
 * @param queryParam The value from router.query (e.g., router.query.id)
 * @returns The validated ID as a string, or null if invalid.
 */
export function validateQueryParamId(queryParam: string | string[] | undefined): string | null {
  if (typeof queryParam !== 'string' || !SAFE_ID_REGEX.test(queryParam)) {
    return null;
  }
  return queryParam;
}
